import { useState } from "react";
import Button from "@demystdata/ui/button";
import { FiPlus } from "react-icons/fi";
import { CreateAddConnectorModal } from "./CreateAddConnectorModal";

export const AddConnectorCard = ({ connectors, setConnector, isFirst }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="AddConnectorCard">
      <h3 className="AddConnectorCard__name">
        {isFirst
          ? "You don't have any connectors added to your Data API yet."
          : "You can add as many connectors as you'd like"}
      </h3>
      <p className="AddConnectorCard__description">
        {isFirst
          ? "To get started, click the button below and add an external data connector. You will be able to access any connector you add when utilizing your Data API."
          : "Connectors in your Data API will share their matching input properties."}
      </p>
      <Button
        className="AddConnectorCard__button"
        leftIconSrc={<FiPlus />}
        onClick={() => setModalOpen(true)}
      >
        {isFirst ? "Add Connector" : "Add Another Connector"}
      </Button>
      <CreateAddConnectorModal
        connectors={connectors}
        setConnector={setConnector}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </section>
  );
};
